import React, { useState, useEffect } from "react";
import { MessageCircle, X, Send, Bot } from "lucide-react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import BackButton from "../BackButton";
import { useLocation, useNavigate } from "react-router-dom";
import { APP_ROUTES } from "../../constants/approutes";
import { startTokenRefresh } from "../../utils/tokenManager";

function OurLayouts({
  
  children,
  cartCount,
  onCartClick,
  patientId,
  hideSidebar = false,
  showBackButton = true,
  backButtonProps = {},
  containScroll = false,
}) {
  const [collapsed, setCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [message, setMessage] = useState("");
  const location = useLocation();

  const navigate = useNavigate();

  console.log("OurLayouts - patientId:", patientId); // Debug log

  // Initialize token refresh when layout mounts
  useEffect(() => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      console.log('Layout mounted with token, starting token refresh...');
      startTokenRefresh();
    }
  }, []);

  const toggleSidebar = () => setIsMobileOpen(!isMobileOpen);

  return (
    <div className="flex h-screen w-full overflow-hidden">
      {/* Sidebar for desktop */}
      <div className="hidden md:block fixed z-50">
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} onNavigate={undefined} />
      </div>

      {!hideSidebar && (
        <div className="hidden md:block fixed z-50">
          <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} onNavigate={undefined} />
        </div>
      )}

      {/* Sidebar drawer for mobile */}
      {isMobileOpen && !hideSidebar && (
        <div className="fixed inset-0 z-50 flex md:hidden">
          {/* Sidebar */}
          <div className="w-64 h-full bg-gradient-to-b from-[#004276] to-[#00BD7F] z-50">
            <Sidebar collapsed={false} onNavigate={toggleSidebar} />
          </div>
          {/* Overlay */}
          <div className="flex-1" onClick={toggleSidebar} />
        </div>
      )}

      {/* Main content area - constrain width when sidebar is open so content is not cut off */}
      <div
        className={
          hideSidebar
            ? "flex-1 flex flex-col min-w-0" // full width when hiding the sidebar
            : `flex-1 flex flex-col min-w-0 transition-all duration-300 ${
                collapsed ? "md:ml-20 md:max-w-[calc(100vw-5rem)]" : "md:ml-64 md:max-w-[calc(100vw-16rem)]"
              }`
        }
      >
        <div className="h-full w-full min-w-0 overflow-x-hidden overflow-y-visible min-h-0">
          <div className="rounded-t-3xl rounded-b-3xl bg-white h-full flex flex-col min-h-0">
            <Header
              toggleSidebar={toggleSidebar}
              cartCount={cartCount}
              onCartClick={onCartClick}
              patientId={patientId}
            />

            {/* Back Button Section */}
            {showBackButton && location.pathname !== APP_ROUTES.DASHBOARD && location.pathname !== APP_ROUTES.SHARECALL &&  location.pathname !== APP_ROUTES.LOGIN && location.pathname !== APP_ROUTES.SIGNUP && (
              <div className="px-4 py-1 border-b border-gray-100 bg-gray-50">
                <BackButton {...backButtonProps} />
              </div>
            )}

            <div
              className={`flex-1 min-w-0 min-h-0 ${
                containScroll
                  ? "overflow-hidden flex flex-col p-4"
                  : "overflow-y-auto overflow-x-auto p-4"
              }`}
            >
              {children}
            </div>
          </div>
        </div>
      </div>
{/* 
      {location.pathname !== "/caresathi" && (
        <div className="fixed bottom-6 right-6 z-50">
          <button
            onClick={() => navigate(APP_ROUTES.CARESATHI)}
            className="group relative w-16 h-16 bg-gradient-to-b from-[#004276] to-[#00BD7F] hover:from-[#003666] hover:to-[#00A86B] rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 flex items-center justify-center border-2 border-white"
          >
    
            <div className="absolute inset-0 rounded-full bg-gradient-to-b from-[#004276] to-[#00BD7F] opacity-30 group-hover:opacity-50 transition-opacity duration-300 blur-sm scale-110"></div>


            <div className="relative z-10">
              <Bot className="w-8 h-8 text-white drop-shadow-md" />
            </div>


            <div className="absolute inset-0 rounded-full bg-gradient-to-b from-[#004276] to-[#00BD7F] animate-ping opacity-20"></div>
          </button>


          <div className="absolute bottom-full right-0 mb-2 px-3 py-2 bg-gray-800 text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap shadow-lg">
            Smart Clinic AI Assistant
            <div className="absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800"></div>
          </div>
        </div>
      )} */}
    </div>
  );
}

export default OurLayouts;
